import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        hasTwilioNumberVendorIntegration() {
            return this.numberVendorIntegrations?.hasOwnProperty('twilio-integration');
        },

        ...mapState(stores.Number, ['numberVendorIntegrations']),
    },

    methods: {},
};
